import React, { Fragment, useState, useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Edit2, Phone, Mail, Eye, Copy, Trash2 } from "react-feather";
import { Link } from "react-router-dom";
import {
  Col,
  Card,
  CardBody,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  CardHeader,
  Button,
  Form,
  Input,
} from "reactstrap";
import DataTable from "react-data-table-component";
import { fetchJobApplications } from "../../../redux/recruiter/job_applications/actions"; // Import your action creator
import { useParams } from "react-router-dom";
import Spinner from "../../Common/Spinner";
import { customStyles } from "../../../Constant";
import { FiFileText } from "react-icons/fi";
import { AVATAR, JOBSEEKER_PROFILE_IMAGE } from "../../../Constant";
import {
  fetchManageCandidates,
  downloadCandidates,
  deleteCandidateRequest,
  resetCandidate,
} from "../../../redux/recruiter/manage_candidates/actions";
import {
  capitalize,
  formatDate,
  handlePhoneCall,
  handleCopyToClipboard,
  handleSendEmail,
  formatExperienceOutput,
  extractAfterLastHyphen,
  generateSlug,
  unslugAndCapitalize,
  formatToInteger,
  convertMonthsToYearsDecimal,
} from "../../../Components/Common/CommonFunction";
import NoDataFound from "../../Common/NoDataFound";
import { emptyField } from "../../../Constant";
import PreviewResumeModal from "../Profile/PreviewResumeModal";
import { showSweetAlert } from "../../Common/SweetAlert";
import { showToast } from "../../Common/Toast";
import { getCandidateStatusColor } from "../../../Constant";
import { PreloaderContext } from "../../../_helper/Preloader/PreloaderContext";
import { LOADER_TIMEOUT } from "../../../Constant";
import { FaCalendarAlt } from "react-icons/fa";
import {
  DefinedRange,
  DateRangePicker,
  defaultStaticRanges,
} from "react-date-range";
import { IoMdCopy } from "react-icons/io";
import { RiMailSendLine } from "react-icons/ri";
import { IoCallOutline } from "react-icons/io5";
import { addContactedCountRequest } from "../../../redux/jobseeker/add_contacted_count/actions";
import { addDays, startOfYear, endOfToday } from "date-fns";
import ViewCandidateDetailModal from "../ManageCandidate/ViewCandidateDetailModal";
import styled from "styled-components";

const JobApplications = () => {
  const dispatch = useDispatch();
  const { showPreloader } = useContext(PreloaderContext);
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState("ALL");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [showPreviewResume, setShowPreviewResume] = useState(false);
  const [resumeData, setResumeData] = useState();
  const [datePickerOpen, setDatePickerOpen] = useState(false); // State to manage date picker visibility
  const [searchQuery, setSearchQuery] = useState(""); // State for search query
  const [showViewCandidateDetails, setShowViewCandidateDetails] = useState(false);



  // custom table styles
  // const customStyles = {
  // headCells: {
  //   style: {
  //     paddingLeft: "8px",
  //     paddingRight: "8px",
  //     whiteSpace: "nowrap",
  //     fontWeight: "600",
  //     fontSize: "13px",
  //   },
  // },
  // cells: {
  //   style: {
  //     paddingLeft: "8px",
  //     paddingRight: "8px",
  //     whiteSpace: "nowrap",
  //     overflow: "hidden",
  //     textOverflow: "ellipsis",
  //     fontSize: "13px",
  //   },
  // },
  // };

  // styled wrapper


  const locale = {
    localize: {
      month: (monthIndex) => {
        const months = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];
        return months[monthIndex];
      },
      day: (dayIndex) => {
        const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        return days[dayIndex];
      },
    },
    formatLong: {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    },
  };

  const [formData, setFormData] = useState({
    dateRange: {
      key: "selection",
      startDate: startOfYear(new Date()), // Start of current year
      endDate: endOfToday(), // Today
      type: "ALL",
    },
  });

  const customStaticRanges = [
    {
      label: "All",
      range: () => ({
        startDate: startOfYear(new Date()), // Start of current year
        endDate: endOfToday(), // Today
        type: "ALL",
      }),
      isSelected(range) {
        const definedRange = this.range();
        return (
          range.type === definedRange.type &&
          range.startDate.getTime() === definedRange.startDate.getTime() &&
          range.endDate.getTime() === definedRange.endDate.getTime()
        );
      },
    },
    {
      label: "Your Candidate",
      range: () => ({
        startDate: startOfYear(new Date()), // Start of current year
        endDate: endOfToday(), // Today
        type: "YOUR_CANDIDATE",
      }),
      isSelected(range) {
        const definedRange = this.range();
        return (
          range.type === definedRange.type &&
          range.startDate.getTime() === definedRange.startDate.getTime() &&
          range.endDate.getTime() === definedRange.endDate.getTime()
        );
      },
    },
    {
      label: "Bulk Upload",
      range: () => ({
        startDate: startOfYear(new Date()), // Start of current year
        endDate: endOfToday(), // Today
        type: "BULK_UPLOAD",
      }),
      isSelected(range) {
        const definedRange = this.range();
        return (
          range.type === definedRange.type &&
          range.startDate.getTime() === definedRange.startDate.getTime() &&
          range.endDate.getTime() === definedRange.endDate.getTime()
        );
      },
    },
    ...defaultStaticRanges.map((range) => ({
      ...range,
      range: () => ({
        ...range.range(),
        type: range.label.toUpperCase().replace(/ /g, "_"), // Generate a type from the label
      }),
      isSelected(range) {
        const definedRange = this.range();
        return (
          range.type === definedRange.type &&
          range.startDate.getTime() === definedRange.startDate.getTime() &&
          range.endDate.getTime() === definedRange.endDate.getTime()
        );
      },
    })),
  ];

  const handleDateRangeChange = (ranges) => {
    const { selection } = ranges;
    let selectedType = "CUSTOM"; // Default to CUSTOM

    // Check if the selected range matches any predefined ranges
    for (let range of customStaticRanges) {
      const definedRange = range.range();
      if (
        selection.startDate.getTime() === definedRange.startDate.getTime() &&
        selection.endDate.getTime() === definedRange.endDate.getTime() &&
        selection.type === definedRange.type
      ) {
        selectedType = definedRange.type;
        break;
      }
    }

    setFormData({
      ...formData,
      dateRange: {
        ...selection,
        type: selectedType, // Set the type based on the selected range
      },
    });
    setDatePickerOpen(false); // Close the date picker after selecting a valid date range
  };

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Handle form submission
  const handleSubmit = (event) => {
    event.preventDefault();
    const data = {
      job_id: extractAfterLastHyphen(id),
      keyword: searchQuery,
      status: activeTab,
      startDate: formData.dateRange.startDate
        ? formData.dateRange.startDate.toISOString()
        : null, // Convert Date objects to strings
      endDate: formData.dateRange.endDate
        ? formData.dateRange.endDate.toISOString()
        : null,
      type: formData.dateRange.type ? formData.dateRange.type : null,
    };
    dispatch(fetchJobApplications(1, perPage, data, sortColumn, sortDirection));
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
  };
  // Access jobApplicationsReducer state from Redux store
  const jobApplicationsReducerData = useSelector(
    (state) => state.jobApplicationsReducer
  );
  const jobApplicationsData = jobApplicationsReducerData.data;

  const tabOptions = [
    {
      value: "ALL",
      label: `APPLIED (${jobApplicationsData.all_count || 0})`,
    },

    // {
    //   value: "VIEWED ",
    //   label: `VIEWED (${jobApplicationsData.view_count || 0})`,
    // },

    {
      value: "SHORTLISTED",
      label: `SHORTLISTED (${jobApplicationsData.shortlisted_count || 0})`,
    },
    {
      value: "INTERVIEWED",
      label: `INTERVIEWED (${jobApplicationsData.interviewed_count || 0})`,
    },
    {
      value: "ON_HOLD",
      label: `ON HOLD (${jobApplicationsData.on_hold_count || 0})`,
    },
    // {
    //   value: "PENDING",
    //   label: `PENDING (${jobApplicationsData.pending_count || 0})`,
    // },

    {
      value: "HIRED ",
      label: `HIRED (${jobApplicationsData.hired_count || 0})`,
    },

    {
      value: "REJECTED",
      label: `REJECTED (${jobApplicationsData.rejected_count || 0})`,
    },
  ];

  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const handleSort = async (column, direction) => {
    setSortColumn(column.short_column);
    setSortDirection(direction);
    // fetchJobs(); // Fetch jobs with new sorting

  };

  useEffect(() => {
    fetchData(activeTab);
  }, [currentPage, perPage, formData, sortColumn, sortDirection]); // Fetch data on initial render

  const fetchData = (value) => {

    const data = {
      job_id: extractAfterLastHyphen(id),
      keyword: searchQuery,
      status: value,
      startDate: formData.dateRange.startDate
        ? formData.dateRange.startDate.toISOString()
        : null, // Convert Date objects to strings
      endDate: formData.dateRange.endDate
        ? formData.dateRange.endDate.toISOString()
        : null,
      type: formData.dateRange.type ? formData.dateRange.type : null,
    };
    dispatch(fetchJobApplications(currentPage, perPage, data, sortColumn, sortDirection)); // Dispatch your action with the selected value
    console.log(`Fetching data for tab: ${value}`);
  };

  const handleTabClick = (value) => {
    setActiveTab(value);
    fetchData(value);
  };

  const handleDelete = (seeker_id) => {
    showSweetAlert("confirm", {
      message: "You want to delete the candidate",
      fun: deleteJob,
      id: seeker_id,
    });
  };

  const deleteJob = (seeker_id) => {
    dispatch(deleteCandidateRequest({ seeker_id: seeker_id, job_id: extractAfterLastHyphen(id) }));
  };
  const manageCandidateReducerData = useSelector(
    (state) => state.manageCandidateReducer
  );
  const candidateData = manageCandidateReducerData.data.data;
  useEffect(() => {
    if (
      manageCandidateReducerData.status &&
      manageCandidateReducerData.message !== ""
    ) {
      showToast("success", manageCandidateReducerData.message);
      fetchData(activeTab);
      dispatch(resetCandidate());
    } else if (
      manageCandidateReducerData.status === false &&
      manageCandidateReducerData.message !== ""
    ) {
      if (showPreloader) {
        setTimeout(() => {
          showToast("error", manageCandidateReducerData.message);
        }, LOADER_TIMEOUT);
      } else {
        showToast("error", manageCandidateReducerData.message);
      }
      dispatch(resetCandidate());
    }
  }, [manageCandidateReducerData]);

  const handleMailClick = (email, seekerId) => {
    handleSendEmail(email);
    dispatch(addContactedCountRequest({ seeker_id: seekerId })); // Dispatch your action with the necessary payload
  };

  const handlePhoneClick = (phone, seekerId) => {
    handlePhoneCall(phone);
    dispatch(addContactedCountRequest({ seeker_id: seekerId })); // Dispatch your action with the necessary payload
  };

  const handleCopyClick = (data, seekerId) => {
    handleCopyToClipboard(data);
    dispatch(addContactedCountRequest({ seeker_id: seekerId }));
  };

  // Define your table columns
  // const tableColumns = [
  //   // {
  //   //   name: "#",
  //   //   cell: (row, index) => index + 1,
  //   //   width: "60px",
  //   //   sortable: true,
  //   //   center: false,
  //   // },
  //   {
  //     name: "Name",
  //     width: "19%",
  //     cell: (row) => (
  //       <div className="d-flex align-items-center gap-2">
  //         <img
  //           className="img-fluid img-30 rounded-circle"
  //           // src={row.jobseeker_photo || AVATAR}
  //           src={row.jobseeker_photo
  //             ? row.jobseeker_photo
  //             : AVATAR}
  //           alt="user"
  //         />
  //         <Link
  //           to={`${process.env.PUBLIC_URL
  //             }/recruiter/job_candidate_detail/view/${generateSlug(
  //               row.jobseeker_full_name,
  //               row.jobseeker_location,
  //               row.seeker_id
  //             )}/${generateSlug(row.jobseeker_full_name, row.job_name, row.id)}`}
  //           title="View Candidate"
  //         >
  //           {capitalize(row.jobseeker_full_name.length > 14 ? row.jobseeker_full_name.substring(0, 14) + "..." : row.jobseeker_full_name) || "-"}
  //         </Link>
  //       </div>
  //     ),
  //     sortable: true,
  //     center: false,
  //   },
  //   {
  //     name: "Email",
  //     short_column: "jobseeker_email1",
  //     // selector: (row) => (
  //     //   <span
  //     //     style={{ cursor: "pointer" }}
  //     //     onClick={() => handleSendEmail(row.jobseeker_email)}
  //     //   >
  //     //     {row.jobseeker_email || "-"}
  //     //   </span>
  //     // ),
  //     center: false,
  //     sortable: true,
  //     // width: "9%",
  //     cell: (row) => (
  //       <>
  //         {row.jobseeker_email1 ? (
  //           <span style={{ cursor: "pointer" }}>
  //             {row.jobseeker_email1 && (
  //               <>
  //                 <div className="mb-2">
  //                   <span
  //                     className="email-tooltip"
  //                     data-bs-toggle="tooltip"
  //                     data-bs-placement="top"
  //                     title={emptyField(row.jobseeker_email1)}
  //                   >
  //                     {emptyField(row.jobseeker_email1.trim()).length > 8
  //                       ? emptyField(row.jobseeker_email1.trim()).substring(
  //                         0,
  //                         8
  //                       ) + "..."
  //                       : emptyField(row.jobseeker_email1.trim())}
  //                   </span>
  //                   <RiMailSendLine
  //                     className="email-icon ms-1"
  //                     title="Email"
  //                     size={17}
  //                     style={{ verticalAlign: "middle" }}
  //                     onClick={() =>
  //                       handleMailClick(row.jobseeker_email1, row.seeker_id)
  //                     }
  //                   />{" "}
  //                   <IoMdCopy
  //                     className="copy-icon "
  //                     size={17}
  //                     style={{ verticalAlign: "middle" }}
  //                     onClick={() =>
  //                       handleCopyClick(row.jobseeker_email1, row.seeker_id)
  //                     }
  //                     title="Copy"
  //                   />{" "}
  //                 </div>
  //               </>
  //             )}
  //             {/* {row.jobseeker_email2 && (
  //               <>
  //                 {emptyField(row.jobseeker_email2.trim()).length > 17
  //                   ? emptyField(row.jobseeker_email2.trim()).substring(0, 17) +
  //                     "..."
  //                   : emptyField(row.jobseeker_email2.trim())}
  //                 <Mail
  //                   size={18}
  //                   color="gray"
  //                   style={{
  //                     marginLeft: "5px",
  //                     marginRight: "5px",
  //                     cursor: "pointer",
  //                     verticalAlign: "middle",
  //                   }}
  //                   onClick={() => handleSendEmail(row.jobseeker_email2)}
  //                 />
  //                 <Copy
  //                   size={18}
  //                   color="gray"
  //                   style={{
  //                     marginLeft: "5px",
  //                     cursor: "pointer",
  //                     verticalAlign: "middle",
  //                   }}
  //                   onClick={() => handleCopyToClipboard(row.jobseeker_email2)}
  //                 />
  //               </>
  //             )} */}
  //           </span>
  //         ) : (
  //           "-" // Show hyphen if email data does not exist
  //         )}
  //         <br />
  //       </>
  //     ),
  //   },
  //   {
  //     name: "Mobile No",
  //     short_column: "jobseeker_phone1",
  //     center: false,
  //     sortable: true, // Ensure this is set to true
  //     // width: "10%",
  //     cell: (row) => (
  //       <>
  //         {row.jobseeker_phone1 ? (
  //           <span style={{ cursor: "pointer" }}>
  //             {row.jobseeker_phone1 && (
  //               <>
  //                 <div className="mb-2">
  //                   <span
  //                     className="email-tooltip"
  //                     data-bs-toggle="tooltip"
  //                     data-bs-placement="top"
  //                     title={emptyField(row.jobseeker_phone1)}
  //                   >
  //                     {row.jobseeker_phone1.length > 10
  //                       ? `${row.jobseeker_phone1.trim().substring(0, 10)}...`
  //                       : row.jobseeker_phone1.trim()}
  //                   </span>
  //                   <IoCallOutline
  //                     className="phone-icon ms-1"
  //                     size={17}
  //                     style={{ verticalAlign: "middle", cursor: "pointer" }}
  //                     onClick={() =>
  //                       handlePhoneClick(row.jobseeker_phone1, row.seeker_id)
  //                     }
  //                     title="Call"
  //                   />{" "}
  //                   <IoMdCopy
  //                     className="copy-icon"
  //                     size={17}
  //                     style={{ verticalAlign: "middle" }}
  //                     onClick={() =>
  //                       handleCopyClick(row.jobseeker_phone1, row.seeker_id)
  //                     }
  //                     title="Copy"
  //                   />{" "}
  //                 </div>
  //               </>
  //             )}
  //             {/* {row.jobseeker_phone2 && row.country_code2 && (
  //               <>
  //                 {`${row.country_code2}${row.jobseeker_phone2.trim()}`}

  //                 <Phone
  //                   size={18}
  //                   color="gray"
  //                   style={{ marginLeft: "5px", cursor: "pointer" }}
  //                   onClick={() => handlePhoneCall(row.jobseeker_phone2)}
  //                 />
  //                 <Copy
  //                   size={18}
  //                   color="gray"
  //                   style={{ marginLeft: "5px", cursor: "pointer" }}
  //                   onClick={() => handleCopyToClipboard(row.jobseeker_phone2)}
  //                 />
  //               </>
  //             )} */}
  //           </span>
  //         ) : (
  //           "-" // Show hyphen if phone data does not exist
  //         )}

  //       </>
  //     ),
  //   },
  //   {
  //     name: "Location",
  //     short_column: "jobseeker_location",
  //     cell: (row) => capitalize(row.jobseeker_location) || "-",
  //     sortable: true,
  //     center: false,
  //     width: "10%",
  //   },
  //   {
  //     name: "Total Exp (Years)",
  //     center: true,
  //     // width: "8%",
  //     cell: (row) => {
  //       const experienceOutput = row.total_exp;
  //       return experienceOutput
  //         ? convertMonthsToYearsDecimal(experienceOutput)
  //         : "-";
  //     },
  //   },
  //   {
  //     name: "Current CTC (LPA)",
  //     center: true,
  //     // width: "8%",
  //     cell: (row) => (
  //       <div style={{ textAlign: "center" }}>
  //         {(row.current_or_latest_salary &&
  //           row.current_or_latest_salary) ||
  //           "-"}
  //       </div>
  //     ),
  //   },
  //   {
  //     name: "EXP CTC (LPA)",
  //     center: true,
  //     // width: "7%",
  //     cell: (row) => (
  //       <div style={{ textAlign: "center" }}>
  //         {(row.jobseeker_preferred_salary &&
  //           row.jobseeker_preferred_salary) ||
  //           "-"}
  //       </div>
  //     ),
  //   },
  //   {
  //     name: "Notice Period (Days)",
  //     center: true,
  //     width: "12%",
  //     cell: (row) =>

  //       row.jobseeker_notice_period ? `${row.jobseeker_notice_period}` : "-",
  //   },
  //   {
  //     name: "Status",
  //     center: true,
  //     // width: "8%",
  //     cell: (row) => (
  //       <span
  //         className={`badge ${getCandidateStatusColor(row.candidate_status)}`}
  //       >
  //         {unslugAndCapitalize(row.candidate_status)}
  //       </span>
  //     ),
  //   },
  //   // {
  //   //   name: "Applied On",
  //   //   center: true,
  //   //   width: "120px",
  //   //   cell: (row) => formatDate(row.created_at) || "-",
  //   // },
  //   {
  //     // width: "12%",
  //     name: "Actions",
  //     center: true,
  //     cell: (row) => (
  //       <div>
  //         <span>
  //           {/* <Link
  //             to={`${process.env.PUBLIC_URL
  //               }/recruiter/job_candidate_detail/view/${generateSlug(
  //                 row.jobseeker_full_name,
  //                 row.jobseeker_location,
  //                 row.seeker_id
  //               )}/${generateSlug(
  //                 row.jobseeker_full_name,
  //                 row.job_name,
  //                 row.id
  //               )}`}
  //             title="View Candidate"
  //           >
  //             <Eye
  //               size={18}
  //               className="eye-icon"
  //               style={{ marginRight: "7px" }}
  //             />
  //           </Link> */}
  //           <span title="View Candidate" style={{ cursor: "pointer", display: "inline-block" }}>
  //             <Eye
  //               onClick={() => handleViewCandidateDetails(row)} // Open modal and pass row data
  //               title="View Candidate"
  //               size={18}
  //               className="eye-icon"
  //               style={{ marginRight: "7px" }}
  //             />
  //           </span>
  //           <Link
  //             to={`${process.env.PUBLIC_URL
  //               }/recruiter/job_candidate_detail/edit/${generateSlug(
  //                 row.jobseeker_full_name,
  //                 row.jobseeker_location,
  //                 row.seeker_id
  //               )}/${generateSlug(
  //                 row.jobseeker_full_name,
  //                 row.job_name,
  //                 row.id
  //               )}`}
  //             title="Edit Candidate"
  //           >
  //             <Edit2
  //               size={18}
  //               className="edit-icon"
  //               style={{ marginRight: "7px" }}
  //             />
  //           </Link>
  //           {row.jobseeker_resume && (
  //             <FiFileText
  //               size={18}
  //               className="file-icon"
  //               style={{ marginRight: "7px", cursor: "pointer" }}
  //               onClick={() => handlePreviewClick(row)}
  //               title="View Resume"
  //             />
  //           )}
  //           <span title="Delete Candidate">
  //             <Trash2
  //               size={18}
  //               onClick={() => handleDelete(row.seeker_id)}
  //               className="delete-icon"
  //               style={{ cursor: "pointer" }}
  //             />
  //           </span>
  //         </span>
  //       </div>
  //     ),
  //   },
  // ];




  // Define your table columns using a flexible and robust approach
  const tableColumns = [
    {
      name: "Name",
      sortable: true,
      grow: 3, // Takes the most of any extra space
      // minWidth: "170px",
      cell: (row) => (
        <div className="d-flex align-items-center gap-2">
          <img
            className="img-fluid img-30 rounded-circle"
            src={row.jobseeker_photo ? row.jobseeker_photo : AVATAR}
            alt="user"
          />
          <Link
            to={`${process.env.PUBLIC_URL}/recruiter/job_candidate_detail/view/${generateSlug(
              row.jobseeker_full_name,
              row.jobseeker_location,
              row.seeker_id
            )}/${generateSlug(row.jobseeker_full_name, row.job_name, row.id)}`}
            title="View Candidate"
            style={{ overflow: "hidden", textOverflow: "ellipsis", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical" }}
          >
            {capitalize(row.jobseeker_full_name)}

          </Link>
        </div>
      ),
    },
    {
      name: "Email",
      short_column: "jobseeker_email1",
      sortable: true,
      grow: 2.5,
      minWidth: "120px",
      cell: (row) => (
        <>
          {row.jobseeker_email1 ? (
            // 1. The MAIN container. It separates the email from the icon group.
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                // justifyContent: 'space-between', // Pushes items to opposite ends
                width: '100%', // Ensures justifyContent works correctly
                gap: '4px',
              }}
            >


              {/* Item 1: The email text (it's a flex item) */}
              <span
                className="email-tooltip text-truncate" // Added text-truncate class for Bootstrap
                data-bs-toggle="tooltip"
                title={emptyField(row.jobseeker_email1)}
                style={{
                  cursor: 'pointer',
                  display: 'inline-block', // Ensure it behaves like a block for truncation
                  maxWidth: '150px', // Set a max width for truncation
                  whiteSpace: 'nowrap', // Prevent text wrapping
                  overflow: 'hidden', // Hide overflow text
                  textOverflow: 'ellipsis', // Show ellipsis for overflow
                }}
              >
                {emptyField(row.jobseeker_email1.trim())}
              </span>


              {/* Item 2: A NEW container for the icons (it's a single flex item) */}
              <div
                style={{
                  display: 'flex', // This is the nested flexbox
                  alignItems: 'center',
                  gap: '8px', // Controls spacing between the icons
                }}
              >
                <RiMailSendLine
                  className="email-icon"
                  title="Email"
                  size={17}
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleMailClick(row.jobseeker_email1, row.seeker_id)}
                />

                <IoMdCopy
                  className="copy-icon"
                  size={17}
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleCopyClick(row.jobseeker_email1, row.seeker_id)}
                  title="Copy"
                />
              </div>
            </div>
          ) : (
            "-"
          )}
        </>
      ),
    },
    {
      name: "Mobile No",
      short_column: "jobseeker_phone1",
      sortable: true,
      grow: 2,
      minWidth: "70px",
      cell: (row) => (
        <>
          {row.jobseeker_phone1 ? (
            <span style={{ cursor: "pointer" }}>
              <div className="" style={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                // justifyContent: 'space-between', // Pushes items to opposite ends
                width: '100%', // Ensures justifyContent works correctly
                gap: '4px',
              }}>
                <span
                  className="email-tooltip text-truncate me-2" // Added text-truncate class for Bootstrap
                  data-bs-toggle="tooltip"
                  title={emptyField(row.jobseeker_phone1)}
                  style={{
                    cursor: 'pointer',
                    display: 'inline-block', // Ensure it behaves like a block for truncation
                    maxWidth: '150px', // Set a max width for truncation
                    whiteSpace: 'nowrap', // Prevent text wrapping
                    overflow: 'hidden', // Hide overflow text
                    textOverflow: 'ellipsis', // Show ellipsis for overflow
                  }}
                >
                  {row.jobseeker_phone1.length > 10
                    ? `${row.jobseeker_phone1.trim().substring(0, 10)}...`
                    : row.jobseeker_phone1.trim()}
                </span>
                <div
                  style={{
                    display: 'flex', // This is the nested flexbox
                    alignItems: 'center',
                    gap: '8px', // Controls spacing between the icons
                  }}
                >
                  <IoCallOutline className="phone-icon" size={17} style={{ verticalAlign: "middle", cursor: "pointer" }} onClick={() => handlePhoneClick(row.jobseeker_phone1, row.seeker_id)} title="Call" />
                  <IoMdCopy className="copy-icon" size={17} style={{ verticalAlign: "middle" }} onClick={() => handleCopyClick(row.jobseeker_phone1, row.seeker_id)} title="Copy" />
                </div>
              </div>
            </span>
          ) : ("-")}
        </>
      ),
    },
    {
      name: "Location",
      short_column: "jobseeker_location",
      cell: (row) => capitalize(row.jobseeker_location) || "-",
      sortable: true,
      grow: 1.5,
      minWidth: "115px",
    },
    {
      name: "Total Exp (Years)",
      center: true,
      grow: 1,
      minWidth: "100px",
      cell: (row) => (row.total_exp ? convertMonthsToYearsDecimal(row.total_exp) : "-"),
    },
    {
      name: "Current CTC (LPA)",
      center: true,
      grow: 1,
      minWidth: "110px",
      cell: (row) => <div style={{ textAlign: "center" }}>{row.current_or_latest_salary || "-"}</div>,
    },
    {
      name: "EXP CTC (LPA)",
      center: true,
      grow: 1,
      minWidth: "100px",
      cell: (row) => <div style={{ textAlign: "center" }}>{row.jobseeker_preferred_salary || "-"}</div>,
    },
    {
      name: "Notice Period (Days)",
      center: true,
      grow: 1,
      minWidth: "130px",
      cell: (row) => (row.jobseeker_notice_period ? `${row.jobseeker_notice_period}` : "-"),
    },
    {
      name: "Status",
      center: true,
      width: "90px", // Use fixed width for consistency, no 'grow'
      cell: (row) => (
        <span className={`badge ${getCandidateStatusColor(row.candidate_status)}`}>
          {unslugAndCapitalize(row.candidate_status)}
        </span>
      ),
    },
    {
      name: "Actions",
      center: true,
      width: "120px", // Use fixed width for icons, no 'grow'
      cell: (row) => (
        <div>
          <span>
            <span title="View Candidate" style={{ cursor: "pointer", display: "inline-block" }}>
              <Eye onClick={() => handleViewCandidateDetails(row)} title="View Candidate" size={18} className="eye-icon" style={{ marginRight: "5px" }} />
            </span>
            <Link
              to={`${process.env.PUBLIC_URL}/recruiter/job_candidate_detail/edit/${generateSlug(row.jobseeker_full_name, row.jobseeker_location, row.seeker_id)}/${generateSlug(row.jobseeker_full_name, row.job_name, row.id)}`}
              title="Edit Candidate"
            >
              <Edit2 size={18} className="edit-icon" style={{ marginRight: "5px" }} />
            </Link>
            {row.jobseeker_resume && (
              <FiFileText size={18} className="file-icon" style={{ marginRight: "5px", cursor: "pointer" }} onClick={() => handlePreviewClick(row)} title="View Resume" />
            )}
            <span title="Delete Candidate">
              <Trash2 size={18} onClick={() => handleDelete(row.seeker_id)} className="delete-icon" style={{ cursor: "pointer" }} />
            </span>
          </span>
        </div>
      ),
    },
  ];














  const togglePreviewResumeModal = () => {
    setShowPreviewResume(false);
  };

  const handlePreviewClick = (row) => {

    setShowPreviewResume(true);
    setResumeData(row);

  };

  const toggleViewCandidateDetailsModal = () => {
    setShowViewCandidateDetails(false);
  };

  const handleViewCandidateDetails = (row) => {

    setShowViewCandidateDetails(true);
    setResumeData(row);

  };

  return (
    <Fragment>
      <Row>
        <Col xs="12" className="box-col-12 xl-100">
          <Card>
            <CardHeader className="p-3">
              <Nav className="nav-pills nav-primary justify-content-between mb-3">
                {tabOptions.map((item) => (
                  <NavItem key={item.value} className="mr-2">
                    <NavLink
                      className={`font-weight-bold  ${activeTab === item.value ? "active " : ""
                        }`}
                      onClick={() => handleTabClick(item.value)}
                      style={{ cursor: "pointer" }}
                    >
                      {item.label}
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>{" "}
              <div className="d-flex flex-wrap justify-content-between align-items-center">
                {/* Search Bar */}

                <Form
                  className="theme-form me-2 flex-grow-1"
                  onSubmit={handleSubmit}
                >
                  <div
                    className="input-group flex-nowrap "
                    style={{ height: 35, maxWidth: "350px" }}
                  >
                    <Input
                      className="form-control"
                      value={searchQuery}
                      onChange={handleSearchChange}
                      type="search"
                      placeholder="Search.."
                    />
                    <Button
                      color="primary"
                      type="submit"
                      className="btn-primary input-group-text pe-3 ps-3"
                    >
                      Search
                    </Button>
                  </div>
                </Form>
                <Link
                  to={`${process.env.PUBLIC_URL}/recruiter/add_candidate/${id}`}
                >
                  <Button
                    color="secondary"
                    className="float-start ps-3 pe-3 me-2 mt-3 mt-md-0"
                  >
                    Add Candidate
                  </Button>
                </Link>

                <div className="d-flex align-items-center ms-auto mt-3 mt-md-0">
                  <Button
                    color="primary"
                    id="shownCalendar"
                    onClick={() => setDatePickerOpen(!datePickerOpen)}
                    className="btn btn-primary d-flex align-items-center ps-3 pe-3"
                  >
                    <FaCalendarAlt className="" />
                    <span className="ms-2">
                      {formData &&
                        (formData.dateRange.type === "CUSTOM"
                          ? `${formatDate(
                            formData.dateRange.startDate,
                            "dd-MM-yyyy"
                          )} - ${formatDate(
                            formData.dateRange.endDate,
                            "dd-MM-yyyy"
                          )}`
                          : unslugAndCapitalize(formData.dateRange.type))}
                    </span>
                  </Button>
                  {datePickerOpen && (
                    <div
                      style={{
                        position: "absolute",
                        top: "50px", // Adjust as needed based on your layout
                        right: "0",
                        zIndex: 1000,
                      }}
                    >
                      {/* <DefinedRange
                          onChange={handleDateRangeChange}
                          ranges={[formData.dateRange]}
                          open={datePickerOpen}
                        /> */}
                      <DateRangePicker
                        editableDateInputs
                        onChange={handleDateRangeChange}
                        ranges={[formData.dateRange]}
                        locale={locale}
                        direction="horizontal"
                        open={datePickerOpen}
                        onToggle={(open) => setDatePickerOpen(open)}
                        staticRanges={customStaticRanges}
                      />
                    </div>
                  )}
                </div>
              </div>
            </CardHeader>

            <CardBody className="px-0 py-3 ">
              <div className="tabbed-card">
                <TabContent activeTab={activeTab}>
                  <TabPane tabId={activeTab}>

                    <div className="table-container">
                      <DataTable

                        responsive
                        customStyles={customStyles}
                        data={
                          jobApplicationsData.data ? jobApplicationsData.data : []
                        }
                        columns={tableColumns}
                        striped={true}
                        center={true}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          jobApplicationsReducerData.data.total
                        }
                        paginationPerPage={perPage}
                        onChangePage={handlePageChange}
                        onChangeRowsPerPage={handlePerRowsChange}
                        progressPending={jobApplicationsReducerData.isLoading}
                        progressComponent={<Spinner />}
                        noDataComponent={
                          <NoDataFound message={"No Candidate Found"} />
                        }
                        onSort={(column, direction) =>
                          handleSort(column, direction)
                        }
                      />
                    </div>

                  </TabPane>
                </TabContent>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      {showPreviewResume && (
        <PreviewResumeModal
          isOpen={showPreviewResume}
          toggleModal={togglePreviewResumeModal}
          data={resumeData}
        />
      )}
      {showViewCandidateDetails && (
        <ViewCandidateDetailModal
          isOpen={showViewCandidateDetails}
          toggleModal={toggleViewCandidateDetailsModal}
          seekerId={resumeData && resumeData.seeker_id}
        />
      )}
    </Fragment>
  );
};

export default JobApplications;
